import styled from 'styled-components';
import {
  color_blue_ss,
  color_dim_purple,
  color_grey_17,
  color_purple,
  color_white,
  largeDesktop,
  smallDesktop,
  tabletPortrait,
} from '../../../styles/generic/global.styles';

export const BluredBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  z-index: 999;
`;

export const CookiePreferences = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 250px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  z-index: 1000;
  background: ${color_white};
  padding: 30px 70px 40px;
  max-width: 850px;
  width: 100%;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.7) 0px 4px 20px, rgba(0, 0, 0, 0.19) 0px 6px 28px;
  animation: fadeIn 0.5s ease-in-out;

  .grey-button {
    color: ${color_purple} !important;
    background: #bfbfbf !important;
  }

  &.expand {
    padding: 10px 18px;
  }

  button {
    border: unset;
    border-radius: 5px;
    font-weight: 700;
  }

  ${tabletPortrait} {
    padding: 20px 0;
    height: fit-content;
  }

  a {
    color: ${color_blue_ss};
    text-decoration: none;
  }

  .cookie-options {
    display: flex;
    flex-direction: column;
  }

  .description {
    max-width: 700px;
    margin: 5px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 20px;

    p {
      margin: 5px 0;
    }

    a {
      font-size: 17px;
      line-height: 30px;
    }

    @media (max-width: 1018px) {
      padding: 10px;
    }
  }

  .manage-cookies-container {
    width: 100%;
    padding: 10px 60px;
    @media (max-width: 1018px) {
      padding: 10px;
    }
    p.mb-3 {
      ${largeDesktop} {
        max-width: 700px;
      }
      ${smallDesktop} {
        max-width: 600px;
      }
      ${tabletPortrait} {
        max-width: 100%;
      }
    }
    form {
      display: flex;
      flex-direction: column;
      @media (max-width: 1018px) {
        display: unset;
      }
    }

    fieldset {
      border: unset;
      margin: 0 0 10px 0;
    }

    .t-switch {
      margin-right: 10px;
    }

    .form-buttons-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0 0 0;
      width: 100%;
      gap: 20px;

      button {
        order: 2;
      }

      button:first-of-type {
        order: 1;
      }

      > button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px !important;
        color: ${color_white};
        background: ${color_purple};

        width: 100%;
        height: 50px;
      }

      @media (max-width: 1018px) {
        width: 100%;
        margin: 10px 0 0 0;
        flex-direction: column;

        button:first-of-type {
          order: 2;
        }
      }
    }
  }

  .title {
    font-size: 25px;
    font-weight: 700;
    line-height: 32px;
    color: ${color_grey_17};
  }

  .buttons-container {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
    margin: 15px auto 0;
    width: 100%;

    ${tabletPortrait} {
      max-width: 700px;
    }

    @media (max-width: 1018px) {
      min-width: 680px;
      height: fit-content;
      gap: 10px;

      button {
        order: 2;
      }

      button:first-of-type {
        order: 1;
      }
    }

    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px !important;
      color: ${color_white};
      background: ${color_purple};

      width: 100%;
      height: 50px;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      width: 100%;
      padding: 20px 10px 0 10px;
      min-width: unset;

      > button {
        width: 100%;
        &:last-of-type {
          margin: 10px 0 0 0;
        }
      }
    }
  }

  .cookie-option {
    font-size: 18px;
    font-weight: 700;
    line-height: 25px;
    color: ${color_grey_17};
    margin: 0 0 5px 0;
  }

  .manage-cookies {
    cursor: pointer;
    margin: auto 0;
    color: ${color_dim_purple};
    font-weight: 700;
    width: fit-content;
    user-select: none;
  }

  @media (max-width: 1018px) {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 769px) {
    top: unset;
    bottom: 0;
    transform: unset;
    transform: translateX(-50%);
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const CookieParagraph = styled.p({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  margin: '5px 0',
});

export const CookieTitle = styled.h3({
  fontSize: '27px',
  fontWeight: 700,
  color: 'var(--lightPurpleColor)',
  margin: '0 0 0 0',

  '@media (max-width: 767px)': {
    display: 'none',
  },
});
